const formatMoney = (cents) => {
  const currency = Shopify.currency?.active || "";
  return `${(cents / 100).toFixed(2)} ${currency}`;
};

const showCartRecommendations = () => {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      if (!cart.items.length) return;

      const lastProductId = cart.items[cart.items.length - 1].product_id;
      return fetch(
        `/recommendations/products.json?product_id=${lastProductId}&limit=10`
      );
    })
    .then((res) => res?.json?.())
    .then((data) => {
      console.log("Recommended Products:", data.products); // 🔍 Log full product objects

      data.products.forEach((p, i) => {
        console.log(
          `Product ${i + 1} - Title: ${p.title}, Featured Image URL:`,
          p.featured_image?.url
        );
      });

      const wrapper = document.getElementById("cart-recommendations");
      const container = document.getElementById(
        "cart-recommendations-products"
      );

      if (!data?.products?.length) return;

      container.innerHTML = data.products
        .map(
          (p) => `
    <div class="swiper-slide">
      <a href="${
        p.url
      }" style="text-decoration: none; color: inherit; display: block;">
      <div class="cart-recom-img-wrapper">
        <img src="${p.featured_image}" alt="${p.title}"/>
        </div>
        <p style="font-weight: 600; margin: 6px 0 2px;color:black;">${
          p.title
        }</p>
        <p style="margin: 0;color:black;font-size: 14px;font-weight:500;">${formatMoney(
          p.price
        )}</p>
        
      </a>
    </div>
  `
        )
        .join("");

      wrapper.style.display = "block";

      new Swiper(".cart-recommendations-swiper", {
        slidesPerView: 2.7,
        spaceBetween: 15,
        navigation: {
          nextEl: ".cart-rec-next",
          prevEl: ".cart-rec-prev",
        },
        pagination: {
          el: ".cart-rec-pagination",
          clickable: true,
        },
      });
    })
    .catch(console.error);
};

// Bind to cart drawer open button (adjust selector as needed)
document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".showcart")
    .forEach((btn) =>
      btn.addEventListener("click", () =>
        setTimeout(showCartRecommendations, 300)
      )
    );
});
